// this code for to add sevak from group list.=> groupid/new sevak

import React, { useState, useEffect } from "react";
import { doc, updateDoc, arrayUnion } from "firebase/firestore";
import { db } from "../firebase";
import { saveSevakData } from "../firebase";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const initialFormState = {
  designation: "",
  accountId: "",
  AdharNumber: "",
  sevakName: "",
  surName: "",
  fatherOrSpouseName: "",
  dob: "",
  age: "",
  mobileNo: "",
  email: "",
  qualification: "",
  profession: "",
  designation: "",
  specialisation: "",
  placeOfWork: "",
  country: "",
  state: "",
  district: "",
  city: "",
  street: "",
  doorNo: "",
  pincode: "",
  nearestTtdTemple: "SV Temple, Jubilee Hills, Hyderabad, Chennai",
  mentallyFit: true,
  physicallyFit: true,
};

const SevakForm = ({ groupId, groupData, onSevakAdded, editMode = false, sevakToEdit = null  }) => {
  // const [formData, setFormData] = useState(initialFormState);
  const [formData, setFormData] = useState(editMode && sevakToEdit ? sevakToEdit : initialFormState);

  const [imagePreview, setImagePreview] = useState(null);
  
  useEffect(() => {
  if (editMode && sevakToEdit) {
    setFormData(sevakToEdit);
  }
}, [editMode, sevakToEdit]);


  // Calculate min and max dates
  const today = new Date();
  const minDate = new Date(
    today.getFullYear() - 80,
    today.getMonth(),
    today.getDate()
  );
  const maxDate = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate()
  );

  const formatDate = (date) => {
    return date.toISOString().split("T")[0]; // YYYY-MM-DD
  };

  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const ageDifMs = today - birthDate;
    const ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  };
  const storage = getStorage();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "dob") {
      const age = calculateAge(value);
      setFormData((prev) => ({
        ...prev,
        dob: value,
        age: age,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const formatDOB = (isoDate) => {
    const [year, month, day] = isoDate.split("-");
    return `${day}/${month}/${year}`;
  };

  // ✅ Utility: Convert image URL to File object
  async function urlToFile(url, filename, mimeType) {
    const response = await fetch(url);
    const blob = await response.blob();
    return new File([blob], filename, { type: mimeType });
  }

  // ✅ Utility: Convert image URL to File object with correct MIME type
  async function urlToFile(url, filename) {
    const response = await fetch(url);
    const blob = await response.blob();
    const mimeType = blob.type || "image/png"; // fallback if type is missing
    return new File([blob], filename, { type: mimeType });
  }

  // ✅ Main submit handler
  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const formattedDOB = formatDOB(formData.dob);
    let downloadURL = formData.profilePicUrl || "";

    // Convert URL to File if needed
    if (!formData.profilePicFile && formData.profilePicUrl) {
      const file = await urlToFile(formData.profilePicUrl, `${formData.accountId || "temp"}_image.png`);
      formData.profilePicFile = file;
    }

    // Upload image if file exists
    if (formData.profilePicFile) {
      const imageId = `${formData.accountId || `${groupId}${(groupData?.members?.length || 0) + 1}`}_image`;
      const storageRef = ref(storage, `sevakImages/${imageId}`);
      await uploadBytes(storageRef, formData.profilePicFile);
      downloadURL = await getDownloadURL(storageRef);
    }

    const groupRef = doc(db, "sevakGroups", groupId);

    if (editMode) {
      // ✅ Update existing Sevak
      const updatedSevak = {
        ...formData,
        dob: formattedDOB,
        profilePicUrl: downloadURL,
      };

      const { profilePicFile, ...sevakDataToSave } = updatedSevak;

      const updatedMembers = groupData.members.map((m) =>
        m.AdharNumber === sevakDataToSave.AdharNumber ? sevakDataToSave : m
      );

      await updateDoc(groupRef, { members: updatedMembers });
      alert("Sevak updated successfully");

      if (onSevakAdded) {
        onSevakAdded(sevakDataToSave);
      }
    } else {
      // ✅ Add new Sevak
      const currentCount = groupData?.members?.length || 0;
      if (currentCount >= 15) {
        alert("Maximum 15 Sevaks allowed per group.");
        return;
      }

      const accountId = `${groupId}${currentCount + 1}`;
      const imageId = `${accountId}_image`;
      const designation = currentCount === 0 ? "teamleader" : "member";

      const newSevak = {
        ...formData,
        dob: formattedDOB,
        accountId,
        imageId,
        profilePicUrl: downloadURL,
        designation,
      };

      const { profilePicFile, ...sevakDataToSave } = newSevak;

      await updateDoc(groupRef, {
        members: arrayUnion(sevakDataToSave),
      });

      alert("Sevak added successfully");

      if (onSevakAdded) {
        onSevakAdded(sevakDataToSave);
      }
    }

    setFormData(initialFormState);
  } catch (error) {
    console.error("Error saving sevak:", error);
    alert("Failed to save sevak");
  }
};


//   const handleSubmit2 = async (e) => {
//     e.preventDefault();

//     const currentCount = groupData?.members?.length || 0;
//     if (currentCount >= 15) {
//       alert("Maximum 15 Sevaks allowed per group.");
//       return;
//     }

//     const accountId = `${groupId}${currentCount + 1}`;
//     const imageId = `${accountId}_image`;
//     const formattedDOB = formatDOB(formData.dob);

//     let downloadURL = "";

//     try {
//       // ✅ If profilePicFile is not set but URL is available
//       if (!formData.profilePicFile && formData.profilePicUrl) {
//         const file = await urlToFile(formData.profilePicUrl, `${imageId}.png`);
//         formData.profilePicFile = file;
//       }

//       // ✅ Log and validate file type
//       console.log("File object:", formData.profilePicFile);
//       console.log("Detected file type:", formData.profilePicFile?.type);

//       const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
//       if (
//         formData.profilePicFile &&
//         !allowedTypes.includes(formData.profilePicFile.type)
//       ) {
//         alert("Please upload a file with .png, .jpg, or .jpeg extension.");
//         return;
//       }

//       // ✅ Upload to Firebase Storage
//       if (formData.profilePicFile) {
//         const storage = getStorage();
//         const storageRef = ref(storage, `sevakImages/${imageId}`);
//        await uploadBytes(storageRef, formData.profilePicFile);
//         downloadURL = await getDownloadURL(storageRef);
//       }

//       // ✅ Prepare data for Firestore (exclude File object)

//       const designation = currentCount === 0 ? "teamleader" : "member";
//       const newSevak = {
//         ...formData,
//         dob: formattedDOB,
//         accountId,
//         imageId,
//         profilePicUrl: downloadURL,
//         designation,
//       };

//       await saveSevakData({ ...newSevak, groupId });

//       if (onSevakAdded) {
//         onSevakAdded(newSevak);
//       }

//       // ✅ Remove File object before saving to Firestore
//       const { profilePicFile, ...sevakDataToSave } = newSevak;

//       const groupRef = doc(db, "sevakGroups", groupId);
//       await updateDoc(groupRef, {
//         members: arrayUnion(sevakDataToSave),
//       });

//       alert("Sevak added successfully");
//       setFormData(initialFormState);
//     } catch (error) {
//       console.error("Error adding sevak:", error);
//       alert("Failed to add sevak");
//     }
//   };

// const handleSubmit1 = async (e) => {
//   e.preventDefault();

//   try {
//     const formattedDOB = formatDOB(formData.dob);
//     let downloadURL = formData.profilePicUrl || "";

//     if (!formData.profilePicFile && formData.profilePicUrl) {
//       const file = await urlToFile(formData.profilePicUrl, `${formData.accountId}_image.png`);
//       formData.profilePicFile = file;
//     }

//     if (formData.profilePicFile) {
//       const storageRef = ref(storage, `sevakImages/${formData.accountId}_image`);
//       await uploadBytes(storageRef, formData.profilePicFile);
//       downloadURL = await getDownloadURL(storageRef);
//     }

//     const updatedSevak = {
//       ...formData,
//       dob: formattedDOB,
//       profilePicUrl: downloadURL,
//     };

//     const { profilePicFile, ...sevakDataToSave } = updatedSevak;
//     const groupRef = doc(db, "sevakGroups", groupId);

//     if (editMode) {
//       const updatedMembers = groupData.members.map((m) =>
//         m.AdharNumber === sevakDataToSave.AdharNumber ? sevakDataToSave : m
//       );
//       await updateDoc(groupRef, { members: updatedMembers });
//       alert("Sevak updated successfully");
//     } else {
//       const currentCount = groupData?.members?.length || 0;
//       if (currentCount >= 15) {
//         alert("Maximum 15 Sevaks allowed per group.");
//         return;
//       }

//       const accountId = `${groupId}${currentCount + 1}`;
//       const imageId = `${accountId}_image`;
//       const designation = currentCount === 0 ? "teamleader" : "member";

//       const newSevak = {
//         ...formData,
//         dob: formattedDOB,
//         accountId,
//         imageId,
//         profilePicUrl: downloadURL,
//         designation,
//       };

//       await updateDoc(groupRef, {
//         members: arrayUnion(newSevak),
//       });

//       alert("Sevak added successfully");
//     }

//     if (onSevakAdded) {
//       onSevakAdded(sevakDataToSave);
//     }

//     setFormData(initialFormState);
//   } catch (error) {
//     console.error("Error saving sevak:", error);
//     alert("Failed to save sevak");
//   }
// };


  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);
    setImagePreview(previewUrl);

    setFormData((prev) => ({
      ...prev,
      profilePicFile: file, 
    }));
  };

  return (
    <form onSubmit={handleSubmit} className="row g-3">
      <div className="col-md-3">
        {imagePreview && (
          <div style={{ marginTop: "10px" }}>
            {" "}
            <img
              src={imagePreview}
              alt="Preview"
              style={{
                width: "150px",
                height: "150px",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />{" "}
          </div>
        )}
        <input
          type="file"
          accept="image/*"
          name="profilePic"
          id="sevakImage"
          onChange={handleImageUpload}
        />
        <label htmlFor="sevakImage" className="form-label">
          Upload Image
        </label>
      </div>
      <div className="col-md-5">
        <label htmlFor="AdharNumber" className="form-label">
          Adhar Number
        </label>
        <input
          type="text"
          className="form-control"
          id="idNumber"
          name="AdharNumber"
          value={formData.AdharNumber}
          onChange={handleChange}
          required
        />
      </div>
      <div className="col-md-4">
        <label htmlFor="sevakName" className="form-label">
          Name
        </label>
        <input
          type="text"
          className="form-control"
          id="sevakName"
          name="sevakName"
          value={formData.sevakName}
          onChange={handleChange}
          required
        />
      </div>
      <div className="col-md-6">
        <label htmlFor="surName" className="form-label">
          Surname
        </label>
        <input
          type="text"
          className="form-control"
          id="surName"
          name="surName"
          value={formData.surName}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-6">
        <label htmlFor="fatherOrSpouseName" className="form-label">
          Father/Spouse Name
        </label>
        <input
          type="text"
          className="form-control"
          id="fatherOrSpouseName"
          name="fatherOrSpouseName"
          value={formData.fatherOrSpouseName}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-3">
        <label htmlFor="dob" className="form-label">
          Date of Birth
        </label>
        <input
          type="date"
          className="form-control"
          id="dob"
          name="dob"
          value={formData.dob}
          onChange={handleChange}
          min={formatDate(minDate)}
          max={formatDate(maxDate)}
          pattern="\d{4}-\d{2}-\d{2}"
          required
        />
      </div>
      <div className="col-md-3">
        <label htmlFor="age" className="form-label">
          Age
        </label>
        <input
          type="number"
          className="form-control"
          id="age"
          name="age"
          value={formData.age}
          onChange={handleChange}
          readOnly
        />
      </div>
      <div className="col-md-6">
        <label htmlFor="mobileNo" className="form-label">
          Mobile Number
        </label>
        <input
          type="text"
          className="form-control"
          id="mobileNo"
          name="mobileNo"
          value={formData.mobileNo}
          onChange={handleChange}
          maxLength="10"
        />
      </div>
      <div className="col-md-6">
        <label htmlFor="email" className="form-label">
          Email
        </label>
        <input
          type="email"
          className="form-control"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-6">
        <label className="form-label d-block">Fitness</label>
        <div className="form-check form-check-inline">
          <input
            type="checkbox"
            className="form-check-input"
            id="mentallyFit"
            name="mentallyFit"
            checked={formData.mentallyFit}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="mentallyFit">
            Mentally Fit
          </label>
        </div>
        <div className="form-check form-check-inline">
          <input
            type="checkbox"
            className="form-check-input"
            id="physicallyFit"
            name="physicallyFit"
            checked={formData.physicallyFit}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="physicallyFit">
            Physically Fit
          </label>
        </div>
      </div>
      <div className="col-md-6">
        <label htmlFor="profession" className="form-label">
          Profession
        </label>
        <input
          type="text"
          className="form-control"
          id="profession"
          name="profession"
          value={formData.profession}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-6">
        <label htmlFor="country" className="form-label">
          India
        </label>
        <input
          type="text"
          className="form-control"
          id="country"
          name="country"
          value={formData.country}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-6">
        <label htmlFor="state" className="form-label">
          State
        </label>
        <input
          type="text"
          className="form-control"
          id="state"
          name="state"
          value={formData.state}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-6">
        <label htmlFor="district" className="form-label">
          District
        </label>
        <input
          type="text"
          className="form-control"
          id="district"
          name="district"
          value={formData.district}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-6">
        <label htmlFor="city" className="form-label">
          City
        </label>
        <input
          type="text"
          className="form-control"
          id="city"
          name="city"
          value={formData.city}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-6">
        <label htmlFor="street" className="form-label">
          Street
        </label>
        <input
          type="text"
          className="form-control"
          id="street"
          name="street"
          value={formData.street}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-3">
        <label htmlFor="doorNo" className="form-label">
          Door No
        </label>
        <input
          type="text"
          className="form-control"
          id="doorNo"
          name="doorNo"
          value={formData.doorNo}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-3">
        <label htmlFor="pincode" className="form-label">
          Pincode
        </label>
        <input
          type="text"
          className="form-control"
          id="pincode"
          name="pincode"
          value={formData.pincode}
          onChange={handleChange}
          maxLength="6"
        />
      </div>
      <div className="col-md-6">
        <label htmlFor="nearestTtdTemple" className="form-label">
          Nearest TTD Temple
        </label>
        <input
          type="text"
          className="form-control"
          id="nearestTtdTemple"
          name="nearestTtdTemple"
          value={formData.nearestTtdTemple}
          onChange={handleChange}
        />
      </div>
      <div className="col-12 text-center mt-3">
        <button type="submit" id="sevakSumbit" className="btn btn-primary">
          Save and Add Sevak
        </button>
      </div>
    </form>
  );
};

export default SevakForm;
